export const Facebook="https://www.facebook.com/KaufmeinTicket/";
export const Instagram="https://www.instagram.com/kaufmeinticket/";